// Controls
import Grid from './components/controls/Grid';
import If from './components/controls/If';
import FormField from './components/controls/FormField';
import RequiredInput from './components/controls/RequiredInput';
import ModalSlider from './components/controls/ModalSlider';
import ModalPopUp from './components/controls/ModalPopUp';
import StaticHeaderForm from './components/controls/StaticHeaderForm';
import TabControl from './components/controls/TabControl';
import Content from './components/controls/Content';
import Expander from './components/controls/Expander';
import BreadcrumbPanel from './components/controls/BreadcrumbPanel';
import FilterContainer from './components/controls/FilterContainer';
import Filter from './components/controls/Filter';
import AutoComplete from './components/controls/Autocomplete';
import MultiSelect from './components/controls/MultiSelect';
import Tree from './components/controls/Tree';
import FilterDropDownList from './components/controls/FilterDropDownList';
import ActionInProgressLoader from './components/controls/ActionInProgressLoader';
import DropDownList from './components/controls/DropDownList';
import DropDownMenu from './components/controls/DropDownMenu';
import ObjectAssignment from './components/controls/ObjectAssignment';
import NavigationBreadcrumbPanel from './components/controls/NavigationBreadcrumbPanel';
import SlideOutTab from './components/controls/SlideOutTab';
import TextEditor from './components/controls/TextEditor';
import DraggablePanel from './components/controls/DraggablePanel';
import FluxGrid from './components/controls/FluxGrid';
import TimePicker from './components/controls/TimePicker';
import DisclosureWidget from './components/controls/DisclosureWidget';
import ColorPicker from './components/controls/ColorPicker';
import DatePicker from './components/controls/DatePicker';
import ValidationInput from './components/controls/ValidationInput';
import GroupBox from './components/controls/GroupBox';
import NumberPicker from './components/controls/NumberPicker';
import Rotator from './components/controls/Rotator';

// Actions
import SlideOutTabActions from './actions/SlideOutTabActions';

// Layout
import IconHeader from './components/controls/layout/IconHeader';
import ToolbarHeader from './components/controls/layout/ToolbarHeader';

// Core
import ReactLoader from './components/core/ReactLoader';
import wrapInAppContainer from './components/core/AppContainer';

// Flux
import AppDispatcher from './flux/AppDispatcher';
import BaseService from './services/BaseService';

// ReactExt
import BaseAppComponent from './components/class/BaseAppComponent';

// System
import SystemActions from './actions/SystemActions';
import SystemStore from './stores/SystemStore';

// Common utilities
import UrlUtilities from './common/UrlUtilities';
import ListHelper from './common/ListHelper';
import FormHelper from './common/FormHelper';
import ColorHelper from './common/ColorHelper';
import DateTimeOffsetHelper from './common/DateTimeOffsetHelper';
import DateTimeFormatHelper from './common/DateTimeFormatHelper';
import DateTime from './common/DateTime/DateTime';
import Time from './common/DateTime/Time';
import CommonMessages from './common/CommonMessages';
import ClipboardHelper from './common/ClipboardHelper';

// Permission
import PermissionService from './services/PermissionService';

// Preferences
import PreferencesActions from './actions/PreferencesActions';
import PreferencesStore from './stores/PreferencesStore';

// WebClient
import WebClientActions from './actions/WebClientActions';
import WebClientStore from './stores/WebClientStore';

// App-level components
import UserProfileAppReadOnly from './components/UserProfile/components/UserProfileAppReadOnly';
import UserLocaleApp from './components/UserLocale/components/UserLocaleApp';

export const Shared = {
    Controls: {
        Grid, If, FormField, RequiredInput, ModalSlider, ModalPopUp,
        StaticHeaderForm, TabControl, Content, Expander, BreadcrumbPanel,
        FilterContainer, Filter, AutoComplete, MultiSelect, Tree,
        FilterDropDownList, ActionInProgressLoader, DropDownList, DropDownMenu,
        ObjectAssignment, NavigationBreadcrumbPanel, SlideOutTab, TextEditor,
        DraggablePanel, FluxGrid, TimePicker, DisclosureWidget, ColorPicker,
        DatePicker, ValidationInput, GroupBox, NumberPicker, Rotator,
    },
    ControlActions: {
        SlideOutTabActions,
    },
    Layout: {
        IconHeader,
        ToolbarHeader,
    },
    Core: {
        ReactLoader,
        wrapInAppContainer,
    },
    Flux: {
        AppDispatcher,
        BaseService,
    },
    ReactExt: {
        BaseAppComponent,
    },
    System: {
        Actions: (SystemActions as any).PublicActions,
        Store: SystemStore,
    },
    Common: {
        UrlUtilities, ListHelper, FormHelper, ColorHelper,
        DateTimeOffsetHelper, DateTimeFormatHelper, DateTime, Time,
        CommonMessages, ClipboardHelper,
    },
    Permission: {
        PermissionService,
    },
    Preferences: {
        Actions: PreferencesActions,
        Store: PreferencesStore,
    },
    WebClient: {
        Actions: WebClientActions,
        Store: WebClientStore,
    },
};

export const App = {
    UserProfile: UserProfileAppReadOnly,
    UserLocale: UserLocaleApp,
};
